export enum FutureLossCertificateManagement {
  Unchanged = 0,
  Keep = 1,
  Stop = 2,
}
